<template>
  <v-card>
    <v-btn @click="$emit('close')" absolute right class="mt-3" icon>
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-btn class="mr-12 mt-3" style="min-width: auto" absolute right color="primary" small @click="print">
      <v-icon>fas fa-print</v-icon>
    </v-btn>
    <v-card-text id="taxLoadInfoWrap">
      <v-card-title><h4 style="word-break: normal; padding-right: 65px">Сведение о сданной в аренду имущества физического лица</h4></v-card-title>
      <column-table v-if="userData" :data="userData" :rows="userDebtHeaders"/>
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnTable from "@/components/ui/table/ColumnTable";
import printTaxInfoMixin from "@/components/calculation/calculator-tax/printTaxInfoMixin";

export default {
  name: 'InfoTaxLoad',
  props: {
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userDebtHeaders: [
        {
          text: 'Код области',
          value: 'ns10_code'
        },
        {
          text: 'Код района',
          value: 'ns11_code'
        },
        {
          text: 'ИНН',
          value: 'tin'
        },
        {
          text: 'Наименование Физ. Лица',
          value: 'company_name'
        },
        {
          text: 'Код объекта',
          value: 'objcode'
        },
        {
          text: 'Наименование объекта',
          value: 'obj_name'
        },
        {
          text: 'Адрес объекта',
          value: 'adress'
        },
        {
          text: 'Инвентаризационная стоимость',
          value: 'inv_salary'
        },
        {
          text: 'Общая площадь',
          value: 'umer_salary'
        },
        {
          text: 'Доля в имуществе',
          value: 'doliya'
        },
        {
          text: 'Общая площадь земли',
          value: 'areanorm'
        },
        {
          text: 'Площадь сверх нормы',
          value: 'areaover'
        }
      ]
    }
  },
  components: {ColumnTable},
  mixins: [printTaxInfoMixin('taxLoadInfoWrap')]
}
</script>